/**
 * Custom hook for accessing user notifications
 * This is a convenience wrapper around UserNotificationContext
 * 
 * Usage:
 *   const { openChatCount, hasNewChatNotification, clearNewChatNotification } = useUserNotifications();
 */

import { useUserNotifications as useUserNotificationsContext } from '../contexts/UserNotificationContext';

export function useUserNotifications() {
  return useUserNotificationsContext();
}

